/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

const documentNavigation = rawData => rawData.all.map(({ doc }) => doc.fields)

export default documentNavigation
